import BasePolicy from '@/policies/BasePolicy.js';

export default class AttendanceCommentPolicy extends BasePolicy {
    /**
     * @param {User} user
     * @param {Course} course
     * @returns boolean
     */
    viewAny(user, course) {
        const permission = 'view all attendance comments';

        return (
            user.hasPermissionViaCourseTo(course, permission) ||
            user.hasGroupPermissionWithinCourse(course, permission) ||
            user.isStudentSupportOfCourse(course.id)
        );
    }

    /**
     * @param {User} user
     * @param {AttendanceComment} attendanceComment
     * @returns boolean
     */
    view(user, attendanceComment) {
        return user.hasPermissionViaCourseTo(attendanceComment.attendance.course, 'view an attendance comment');
    }

    /**
     * @param {User} user
     * @param {Course} course
     * @returns boolean
     */
    create(user, course) {
        if (user.isStudentSupportOfCourse(course.id)) {
            return false;
        }

        const permission = 'create an attendance comment';

        return (
            user.hasPermissionViaCourseTo(course, permission) || user.hasUnlimitedScopePermissionTo(course, permission)
        );
    }

    /**
     * @param {User} user
     * @param {AttendanceComment} attendanceComment
     * @returns boolean
     */
    update(user, attendanceComment) {
        const { course } = attendanceComment.attendance;

        if (user.isStudentSupportOfCourse(course.id)) {
            return false;
        }

        const permission = 'edit an attendance comment';

        return (
            user.hasPermissionViaCourseTo(course, permission) || user.hasUnlimitedScopePermissionTo(course, permission)
        );
    }

    /**
     * @param {User} user
     * @param {AttendanceComment} attendanceComment
     * @returns boolean
     */
    delete(user, attendanceComment) {
        const { course } = attendanceComment.attendance;

        if (user.isStudentSupportOfCourse(course.id)) {
            return false;
        }

        const permission = 'delete an attendance comment';

        return (
            user.hasPermissionViaCourseTo(course, permission) || user.hasUnlimitedScopePermissionTo(course, permission)
        );
    }
}
